import Keycloak from 'keycloak-js';
import { env } from '@/lib/env';

const keycloakConfig = {
    url: env.NEXT_PUBLIC_KEYCLOAK_URL,
    realm: env.NEXT_PUBLIC_KEYCLOAK_REALM,
    clientId: env.NEXT_PUBLIC_KEYCLOAK_CLIENT_ID,
};

const keycloak = new Keycloak(keycloakConfig);

const KEYCLOAK_INIT_TIMEOUT_MS = 5000;

export const initKeycloak = (onAuthenticatedCallback: () => void) => {
    const hasAuthCallback = window.location.href.includes('code=') && window.location.href.includes('state=');
    let hasCompleted = false;
    const complete = () => {
        if (hasCompleted) return;
        hasCompleted = true;
        onAuthenticatedCallback();
    };

    // Timeout: render the app even if Keycloak SSO check hangs
    // (e.g. iframe blocked by CSP frame-ancestors)
    const fallbackTimeout = hasAuthCallback ? undefined : window.setTimeout(() => {
        console.warn('Keycloak initialization timed out — rendering app without authentication');
        complete();
    }, KEYCLOAK_INIT_TIMEOUT_MS);

    keycloak
        .init({
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
            silentCheckSsoFallback: false,
            pkceMethod: 'S256',
            checkLoginIframe: false,
        })
        .then(() => {
            if (fallbackTimeout) window.clearTimeout(fallbackTimeout);
            complete();
        })
        .catch((err: unknown) => {
            console.error('Keycloak initialization error:', err);
            if (fallbackTimeout) window.clearTimeout(fallbackTimeout);
            complete();
        });
};

export default keycloak;
